var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('b-modal',{ref:"myModal",staticClass:"app_modal",attrs:{"centered":"","hide-footer":"","hide-header":""}},[_c('div',{staticClass:"flex-center m-5"},[_c('b-spinner',{attrs:{"type":"grow"}})],1)]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }